var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame243({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"Caret Down\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5476 34H39.4524C40.8294 34 41.5179 35.6632 40.5432 36.638L30.5947 46.5943C29.9912 47.1977 29.0088 47.1977 28.4053 46.5943L18.4568 36.638C17.4821 35.6632 18.1706 34 19.5476 34Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame243);
export default __webpack_public_path__ + "static/media/Frame 243.a53a1e4e4c266d298f35076bd3e4e090.svg";
export { ForwardRef as ReactComponent };